exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-tender__info-item-subtitle[data-v-eb73fa40] {\n    font-size: 1.2rem;\n    color: rgb(54, 54, 54);\n    opacity: 1;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #ccccccc7;\n    position: relative;\n    z-index: 20;\n}\n.belena[data-v-eb73fa40] {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #FFF;\n    opacity: .4;\n    z-index: 10;\n}\n", ""]);

// exports
